import { useLocalization } from '~src/hooks';

export const useFormRequiredFieldRules = () => {
  const translate = useLocalization();

  return [{ required: true, message: `${translate.FORM_FIELD_REQUIRED}` }];
};
